import React from 'react';
import Magazin, { MagazinType } from './Magazin';

type Props = {
  magazins: MagazinType[];
};

function Magazins(props: Props) {
  const { magazins } = props;

  return (
    <div className='magazins component streamfield'>
      <h2>Weitere Interessante Artikel</h2>
      <div className='magazin-list'>
        {magazins.map(magazin => (
          <div className='magazin-list-item' key={magazin.id}>
            <a href={magazin.full_url}>
              <Magazin magazin={magazin} />
            </a>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Magazins;
